import {WithoutSummaryModel} from "../../../../../../common/entity/dto/plain/withoutSummary.model";
import {PaymentRequestSummaryModel} from "../../../api/entity/paymentRequestSummary.model";
import {
    AccountingMovementSummaryModel
} from "../../../../../../accounting/movement/api/entity/accountingMovementSummary.model";

export class PaymentRequestMovementModel extends WithoutSummaryModel {
    paymentRequest: PaymentRequestSummaryModel;
    accountingMovement: AccountingMovementSummaryModel;
    amount: number;
    products: string[] = [];
}